var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"svgContent",staticClass:"div",style:(("\n    width: " + _vm.width + ";\n    height: " + _vm.height + ";\n  "))})}
var staticRenderFns = []

export { render, staticRenderFns }